import isPropValid from '@emotion/is-prop-valid'
import { styled, TableRow } from '@mui/material'

export const StripedTableRow = styled(TableRow, {
    shouldForwardProp: isPropValid,
})<{ active?: boolean }>(({ theme, active }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    outline: active ? `1px solid ${theme.palette.primary.main}` : 'none',
}))
